export const COMMUNICATIONS_EMAIL = "communications@figloans.com";

export const FIG_MAILING_ADDRESS = {
  name: "Fig Loans",
  street: "9450 SW Gemini Dr",
  suite: "Suite 93137",
  city: "Beaverton",
  state: "Oregon",
  zip: "97008-7105"
};